import style from "./style.module.scss";
import nikotan from "./nikotan.png";
const StartApp = ({ setStep }) => {
    const NextToStep = () => {
        setStep("step2")
    }
    return (
        <>
            <div className={style.body}>
                <div className="d-flex justify-content-center">
                    <div className={style.parentImg}>
                        <img src={nikotan} className={style.NikotanImg} alt="logo app" />
                        <p className={style.textNikotan}>همراه همیشگی سلامت</p>
                    </div>
                </div>
                <div className={style.parentBtnStart}>
                    <button className={style.btnStart} onClick={() => NextToStep()}>
                        شروع
                    </button>
                </div>
            </div>
        </>
    );
}

export default StartApp;